import http from "./http-common";
import authHeader from "./auth-header";
import process from "shelljs";

const API_URL = process.env.BFF_URL;

class CustomerStatementService {

  create(mid, customerStatement) {
    const context = JSON.parse(localStorage.getItem('selectedContext'));
    if (!context || !context.contextId) {
      throw new Error('Customer context is required');
    }
    const customerId = context.contextId;
    return http.post(API_URL + `/v1/customers/${customerId}/statement`, customerStatement, {headers: authHeader()});
  }

  update(mid, id, customerStatement) {
    const context = JSON.parse(localStorage.getItem('selectedContext'));
    if (!context || !context.contextId) {
      throw new Error('Customer context is required');
    }
    const customerId = context.contextId;
    return http.put(API_URL + `/v1/customers/${customerId}/statement/${id}`, customerStatement, {headers: authHeader()});
  }

  findById(mid, id) {
    const context = JSON.parse(localStorage.getItem('selectedContext'));
    if (!context || !context.contextId) {
      throw new Error('Customer context is required');
    }
    const customerId = context.contextId;
    return http.get(API_URL + `/v1/customers/${customerId}/statement/${id}`, {headers: authHeader()});
  }

  delete(mid, id) {
    const context = JSON.parse(localStorage.getItem('selectedContext'));
    if (!context || !context.contextId) {
      throw new Error('Customer context is required');
    }
    const customerId = context.contextId;
    return http.delete(API_URL + `/v1/customers/${customerId}/statement/${id}`, {headers: authHeader()});
  }

  find(mid, params) {
    const context = JSON.parse(localStorage.getItem('selectedContext'));
    if (!context || !context.contextId) {
      throw new Error('Customer context is required');
    }
    const customerId = context.contextId;
    return http.get(API_URL + `/v1/customers/${customerId}/statement`, {params: params, headers: authHeader()})
  }

  downloadStatement(merchantId, id) {
    const context = JSON.parse(localStorage.getItem('selectedContext'));
    if (!context || !context.contextId) {
      throw new Error('Customer context is required');
    }
    const customerId = context.contextId;
    return http.get(API_URL + `/v1/customers/${customerId}/statement/${id}/pdf`, {
      responseType: 'arraybuffer',
      headers: authHeader()
    })
  }

  emailStatement(merchantId, id) {
    const context = JSON.parse(localStorage.getItem('selectedContext'));
    if (!context || !context.contextId) {
      throw new Error('Customer context is required');
    }
    const customerId = context.contextId;
    return http(API_URL + `/v1/customers/${customerId}/statement/${id}/email`, {
      method: 'POST',
      headers: authHeader()
    })
  }
}

export default new CustomerStatementService();



// WEBPACK FOOTER //
// ./src/service/customer.statement.service.js